const darkClasses = "dark:fill-palette-secondary"
const classes = "fill-light-bg"

export default function IconSearch(props) {
  return (
    <svg
      className={`w-5 ${props.svg}`}
      viewBox="0 0 16 17"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className={`${classes} ${darkClasses} ${props.className}`}
        d="M11.4351 10.5629H10.7124L10.4563 10.3159C11.3528 9.27301 11.8925 7.9191 11.8925 6.44625C11.8925 3.16209 9.23042 0.5 5.94625 0.5C2.66209 0.5 0 3.16209 0 6.44625C0 9.73042 2.66209 12.3925 5.94625 12.3925C7.4191 12.3925 8.77301 11.8528 9.81589 10.9563L10.0629 11.2124V11.9351L14.6369 16.5L16 15.1369L11.4351 10.5629V10.5629ZM5.94625 10.5629C3.66838 10.5629 1.82962 8.72413 1.82962 6.44625C1.82962 4.16838 3.66838 2.32962 5.94625 2.32962C8.22413 2.32962 10.0629 4.16838 10.0629 6.44625C10.0629 8.72413 8.22413 10.5629 5.94625 10.5629Z"
      />
    </svg>
  );
};
